import React, { useState } from "react";
import '../../css/elements.css';
import Icon from "../../assets/icons/icon";



function SelectBox({ title, handleChange, value, options, passBack }) {
    console.log(options);

    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(value);
    //const options=['List Item 1','List Item 2','List Item 3']
  
    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };
  
    const handleOptionClick = (option) => {
      setSelectedOption(option.name);
      setIsOpen(false);
      handleChange(option,passBack);
    };
    return (
        <div className="selectInputContainer">
            {title && (
                <div className="selectInputTitleWrapper">
                    <span className="selectInputTitle">{title}</span>
                </div>
            )}
            <div className="custom-dropdown textInputBox">
                <div className="selectBoxSelectedItem" onClick={toggleDropdown}>
                    <span className="selectBoxName">{selectedOption || 'Select an option'}</span>
                    <span className={`selectBoxIconWrapper ${isOpen ? 'rotate':''}`} style={{marginTop: `${isOpen ? '40px': '-18px'}`,lineHeight: '50px'}}><span className="fontello"><Icon name={'q-up'} size={24} className="closeIcon" adjust="fontello" /></span></span>

                </div>
                {isOpen && (
                    <div className="selectBoxOptionWrapper">
                    {options.map((option, index) => (
                        console.log(option.name),
                        <div
                            key={option.id}
                            className="selectBoxOption"
                            onClick={() => handleOptionClick(option)}
                        >
                            {option.name}
                        </div>
                    ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default SelectBox;

/*

className="textInputBox"*/